import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";
import { PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { FaChartLine } from "react-icons/fa6";
import { BsGraphUp } from "react-icons/bs";
import { MdMarkChatRead, MdMarkChatUnread } from "react-icons/md";
import { RiRefreshLine } from "react-icons/ri";
import { TbCalendarCheck, TbCalendarPlus } from "react-icons/tb";
import { PiWarning } from "react-icons/pi";

const NotificationOverview = () => {
  const [notificationListCount, setNotificationListCount] = useState(0);
  const [totalOpenNotification, setTotalOpenNotification] = useState(0);
  const [totalClosedNotification, setTotalClosedNotification] = useState(0);
  const [todayTotalOpenNotification, setTodayTotalOpenNotification] = useState(0);
  const [todayTotalCloseNotification, setTodayTotalCloseNotification] = useState(0);
  const [totalReopenNotification, setTotalReopenNotification] = useState(0);
  const [oldestOpenNotification, setOldestOpenNotification] = useState("");
  const [totalAverageNotificationBySubject, setTotalAverageNotificationBySubject] = useState(0);
  const [totalAverageNotificationByForm, setTotalAverageNotificationByForm] = useState(0);
  const [loading, setLoading] = useState(false);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getStudyFormFieldNotificationOverview = async (e) => {
    setLoading(true);
    let userData = {};
    userData.studyId = studyId;
    userData.mode = StudyMode;
    let data =
      await studySiteDataEntryServices.getStudyFormFieldNotificationOverview(
        userData
      );
    if (data === "AbortError") {
      setLoading(true);
    } else {
      setNotificationListCount(data?.count || 0);
      setTotalOpenNotification(data?.totalOpenNotification || 0);
      setTotalClosedNotification(data?.totalClosedNotification || 0);
      setTodayTotalOpenNotification(data?.totalTodayOpenNotificationCount || 0);
      setTodayTotalCloseNotification(data?.totalTodayCloseNotificationCount || 0);
      setTotalReopenNotification(data?.totalReopenNotificationCount || 0);
      setOldestOpenNotification(data?.oldestOpenNotification);
      setTotalAverageNotificationBySubject(data?.totalAverageNotificationBySubject || 0);
      setTotalAverageNotificationByForm(data?.totalAverageNotificationByForm || 0);
      setLoading(false)
    }
  };

  const overviewCards = [
    {
      title: "Total Notifications",
      value: notificationListCount,
      subtitle: "All Notifications generated in study",
      icon: <BsGraphUp className="bg-white text-dark shadow-sm" />,
    },
    {
      title: "Open Notifications",
      value: totalOpenNotification,
      subtitle: "Pending site response",
      icon: <MdMarkChatUnread className="bg-white text-primary shadow-sm" />,
    },
    {
      title: "Closed Notifications",
      value: totalClosedNotification,
      subtitle: "Reviewed and closed",
      icon: <MdMarkChatRead className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Re-opened Notifications",
      value: totalReopenNotification,
      subtitle: "Opened again after closure",
      icon: <RiRefreshLine className="bg-white text-warning shadow-sm" />,
    },
    {
      title: "Oldest Open Notification",
      value: oldestOpenNotification,
      subtitle: "Longest unresolved Notification",
      icon: <PiWarning className="bg-white text-danger shadow-sm" />,
    },
    {
      title: "Notification Rate / Subject",
      value: totalAverageNotificationBySubject,
      subtitle: "Notifications per enrolled subject",
      icon: <FaChartLine className="bg-white text-secondary shadow-sm" />,
    },
    {
      title: "Notification Rate / Form",
      value: totalAverageNotificationByForm,
      subtitle: "Notifications per completed form",
      icon: <FaChartLine className="bg-white text-secondary shadow-sm" />,
    },
    {
      title: "Created Today",
      value: todayTotalOpenNotification,
      subtitle: "New Notifications today",
      icon: <TbCalendarPlus className="bg-white text-primary shadow-sm" />,
    },
    {
      title: "Closed Today",
      value: todayTotalCloseNotification,
      subtitle: "Notifications closed today",
      icon: <TbCalendarCheck className="bg-white text-success shadow-sm" />,
    },
    // {
    //   title: "DB Lock Readiness",
    //   value: "12.3%",
    //   subtitle: "Subjects without open Notifications",
    //   icon: <PiDatabase className="bg-white text-danger shadow-sm" />,
    // },
  ];

  useEffect(() => {
    getStudyFormFieldNotificationOverview();
  }, []);

  return (
    <>
      <div className="overflow-auto" style={{ height: "calc(100vh - 145px)" }}>
        {loading ? (
          <PageLoader />
        ) :
          <Container fluid>
            <Row className="g-2 py-2">
              {overviewCards?.map((item, index) => (
                <Col xl={3} lg={4} md={6} sm={12} key={index}>
                  <Card className="app-card bg-light border h-100">
                    <Card.Body>
                      <div className="d-flex gap-3">
                        <div className="study_icopn">
                          {item.icon}
                        </div>
                        <div>
                          <Card.Title style={{ fontSize: 16 }}>{item.title}</Card.Title>
                          <Card.Text className="m-0">{item.value || "0"}</Card.Text>
                          <Card.Text style={{ fontSize: 11 }}>{item.subtitle}</Card.Text>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        }
      </div>
    </>
  );
};

export default NotificationOverview;
